import { render, staticRenderFns } from "./CardDesign.vue?vue&type=template&id=170d765d&scoped=true"
import script from "./CardDesign.vue?vue&type=script&lang=js"
export * from "./CardDesign.vue?vue&type=script&lang=js"
import style0 from "./CardDesign.vue?vue&type=style&index=0&id=170d765d&prod&scoped=true&lang=css"
import style1 from "./CardDesign.vue?vue&type=style&index=1&id=170d765d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170d765d",
  null
  
)

export default component.exports